/**
 * localStorage['meridian.theme'] with try/catch (F17 · Safari private mode).
 */
export type ThemePreference = 'dark' | 'light';

export const THEME_STORAGE_KEY = 'meridian.theme';

export function readStoredTheme(): ThemePreference | null {
  try {
    const raw = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (raw === 'dark' || raw === 'light') return raw;
    return null;
  } catch {
    return null;
  }
}

export function writeStoredTheme(theme: ThemePreference): void {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    /* storage may throw — theme still applies in-session */
  }
}
